import { render, staticRenderFns } from "./airMarkupPopup.vue?vue&type=template&id=35370a43&scoped=true&"
import script from "./airMarkupPopup.vue?vue&type=script&lang=js&"
export * from "./airMarkupPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35370a43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35370a43')) {
      api.createRecord('35370a43', component.options)
    } else {
      api.reload('35370a43', component.options)
    }
    module.hot.accept("./airMarkupPopup.vue?vue&type=template&id=35370a43&scoped=true&", function () {
      api.rerender('35370a43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/airMarkupPopup.vue"
export default component.exports